import {
  CLEARED_SPOTLIGHTS_STATE,
  MEETINGS_ONBOARDING_TOUR_SPOTLIGHT_KEY,
} from './spotlights'

/**
 * Resets all known spotlight dismissals for debug QA — preserves other activation_data fields.
 * Shared by App Shell debug tools; keep CLEARED_SPOTLIGHTS_STATE in spotlights.js in sync with product keys.
 */
export function clearAllSpotlightsFromActivationData(activationData) {
  const existingSpotlights = activationData?.spotlights

  return {
    ...(activationData ?? {}),
    spotlights: {
      ...existingSpotlights,
      ...CLEARED_SPOTLIGHTS_STATE,
    },
  }
}

export function isMeetingsOnboardingTourDismissed(activationData) {
  const spotlights = activationData?.spotlights
  return spotlights?.[MEETINGS_ONBOARDING_TOUR_SPOTLIGHT_KEY] === true
}
